import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addToCart, decreaseFromCart, deleteFromCart } from '../redux/cart/actions';
import { decreaseQuantity, increaeQuantity } from '../redux/products/actions';


function Cart() {
    //Hooks
    const cart = useSelector((state) => state.cart);
    const products = useSelector((state) => state.products.products);
    const dispatch = useDispatch();



    //Functions
    const getProduct = (productId) => {
        const product = products.find(product => product.id === productId);
        return product;
    }

    const handleCartQuantityChange = (productId, isIncrease) => {
        if (isIncrease) {
            dispatch(addToCart(productId));
            dispatch(decreaseQuantity(productId));
        } else {
            dispatch(decreaseFromCart(productId));
            dispatch(increaeQuantity({ productId, quantity: 1 }));
        }
    }

    const handleDeleteFromCart = (productId, quantity) => {
        dispatch(deleteFromCart(productId));
        dispatch(increaeQuantity({ productId, quantity }));
    }

    const getTotal = () => {
        return cart
            .map(item => {
                const { productId, quantity } = item;
                const { price } = products.find(product => product.id === productId);
                return quantity * price;
            })
            .reduce((acc, curr) => acc + curr, 0);
    }





    return (
        <div class="container 2xl:px-8 px-2 mx-auto">
            <h2 class="mb-8 text-xl font-bold">Shopping Cart</h2>
            <div class="cartListContainer">
                <div class="space-y-6">
                    {/* <!-- Cart Item --> */}
                    {cart.map((cartItem, index) => {
                        const { productId, quantity } = cartItem;
                        const { name, category, price, imgURL, quantity: productQuantity } = getProduct(productId);
                        return (
                            <div class="cartCard" key={productId}>
                                <div class="flex items-center col-span-6 space-x-6">
                                    {/* <!-- cart image --> */}
                                    <img class="lws-cartImage" src={imgURL} alt="product" />
                                    {/* <!-- cart item info --> */}
                                    <div class="space-y-2">
                                        <h4 class="lws-cartName">{name}</h4>
                                        <p class="lws-cartCategory">{category}</p>
                                        <p>BDT <span class="lws-cartPrice">{price}</span></p>
                                    </div>
                                </div>
                                <div class="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
                                    {/* <!-- amount buttons --> */}
                                    <div class="flex items-center space-x-4">
                                        <button class="lws-incrementQuantity" disabled={productQuantity <= 0} onClick={() => handleCartQuantityChange(productId, true)}>
                                            <i class="text-lg fa-solid fa-plus"></i>
                                        </button>
                                        <span class="lws-cartQuantity">{quantity}</span>
                                        <button class="lws-decrementQuantity" disabled={quantity <= 1} onClick={() => handleCartQuantityChange(productId, false)}>
                                            <i class="text-lg fa-solid fa-minus"></i>
                                        </button>
                                    </div>
                                    {/* <!-- price --> */}
                                    <p class="text-lg font-bold">BDT <span class="lws-calculatedPrice">{quantity * price}</span></p>
                                </div>
                                {/* <!-- delete button --> */}
                                <div class="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
                                    <button class="lws-removeFromCart" onClick={() => handleDeleteFromCart(productId, quantity)}>
                                        <i class="text-lg text-red-400 fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        )
                    })}


                </div>

                {/* <!-- Bill Details --> */}
                <div>
                    <div class="billDetailsCard">
                        <h4 class="mt-2 mb-8 text-xl font-bold text-center">Bill Details</h4>
                        <div class="space-y-4">
                            {/* <!-- sub total --> */}
                            <div class="flex items-center justify-between">
                                <p>Sub Total</p>
                                <p>BDT <span class="lws-subtotal">{getTotal()}</span></p>
                            </div>
                            {/* <!-- Discount --> */}
                            <div class="flex items-center justify-between">
                                <p>Discount</p>
                                <p>BDT <span class="lws-discount">0</span></p>
                            </div>
                            {/* <!-- VAT --> */}
                            <div class="flex items-center justify-between">
                                <p>VAT</p>
                                <p>BDT <span class="vat">0</span></p>
                            </div>
                            {/* <!-- Total --> */}
                            <div class="flex items-center justify-between pb-4">
                                <p class="font-bold">TOTAL</p>
                                <p class="font-bold">BDT <span class="lws-total">{getTotal()}</span></p>
                            </div>
                            <button class="placeOrderbtn">place order</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cart